<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 d-flex justify-content-between">
               <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
               <b-button v-b-modal.new-account size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Member</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner type="grow" small class="align-middle"></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(account)="data">
                {{ data.item.account.acc_name }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(telephone)="data">
                0{{ data.item.patient.telephone }}
              </template>
              <template #cell(address)="data">
                {{ data.item.patient.address }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              <template #cell(members)="data">
                  <div class="btn-group">
                    <router-link :to="{ path: '/accountmembers',  query: { id: data.item.acc_number }}" type="button" class="btn-sm btn btn-dark"> <i class="fas fa-users"></i></router-link>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-account" centered title="New Account Member" title-class="font-18" hide-footer>
        <form @submit.prevent="addItem">
            <div class="form-group mb-2">
            <label>Patient</label>
            <multiselect v-model="patient" :options="patients" label="name"></multiselect>
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-account')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-account" centered title="Delete Account Member" title-class="font-18" hide-footer>
        <form @submit.prevent="removeItem">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Member : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-account')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import { groupaccountmemberMethods, groupaccountmemberComputed } from "@/state/helpers";
import { patientMethods, patientComputed } from "@/state/helpers";

export default {
  page: {
    title: "Account Members",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader,Multiselect
  },
  data() {
    return {
      title: "Account Members",
      items: [ {text: "Dashboard",to: "/",}, {text: "Account Members",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'account', label: 'Acc Name', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'telephone', label: 'Contact', visible: true },
          { key: 'address', label: 'Address', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      account:'',
      patient:'',
    };
  },
  computed: {
    ...groupaccountmemberComputed,
    ...patientComputed,
    List() { return this.groupaccountmembers.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.groupaccountmembers.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.groupaccountmembers.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchPatients();
    this.fetchGroupAccountMembers({acc_number:this.$route.query.id});
    this.TotalRows = this.groupaccountmembers.length;
    this.isBusy=false;
  },
  methods: {
    ...groupaccountmemberMethods,
    ...patientMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('edit-account')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-account')
    },
    async addItem() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("acc_number", this.$route.query.id);
      let url = "/addgroupaccountmember";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchGroupAccountMembers({acc_number:this.$route.query.id});
          this.$bvModal.hide('new-account');
          this.patient="";
        }
      });
    },
    async editItem(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    let url = "/updategroupaccount";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchGroupAccounts();
        this.$bvModal.hide('edit-account');
        this.name="";
      }
    });
    },
    async removeItem() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removegroupaccount";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchGroupAccounts();
        this.$bvModal.hide('delete-account');
      }
    });
    },
  },
};
</script>